import { jsxs, jsx } from 'react/jsx-runtime';
import { InfoBadge } from '@box/blueprint-web-assets/icons/Fill';
import { clsx } from 'clsx';
import { Tooltip } from '../../tooltip/tooltip.js';
import { InteractiveIcon } from '../interactive-icon/interactive-icon.js';
import styles from './text-with-info-badge.module.js';

var TextWithInfoBadge = function TextWithInfoBadge(props) {
  var children = props.children,
      className = props.className,
      id = props.id,
      infoText = props.infoText,
      infoBadgeAriaLabel = props.infoBadgeAriaLabel,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'default' : _props$variant,
      _props$tooltipPositio = props.tooltipPosition,
      tooltipPosition = _props$tooltipPositio === void 0 ? 'top' : _props$tooltipPositio;
  return jsxs("div", {
    className: clsx(styles.text, styles[variant], className),
    id: id,
    children: [children, infoText && infoBadgeAriaLabel && jsx("span", {
      className: styles.badgeContainer,
      children: jsx(Tooltip, {
        content: infoText,
        side: tooltipPosition,
        children: jsx(InteractiveIcon, {
          "aria-label": infoBadgeAriaLabel,
          className: styles.badge,
          icon: InfoBadge
        })
      })
    })]
  });
};

export { TextWithInfoBadge };